import { render } from "./TaskSlider2.vue?vue&type=template&id=80a42508&scoped=true"
import script from "./TaskSlider2.vue?vue&type=script&lang=js"
export * from "./TaskSlider2.vue?vue&type=script&lang=js"

import "./TaskSlider2.vue?vue&type=style&index=0&id=80a42508&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80a42508"]])

export default __exports__